<!-- <p>edit-sensor works!</p> -->
<app-dialog-header headerIcon="sensors" headerText="Modify {{SelectedSensor.Name}} Neuron Sensor"
	(onCloseClick)="onCancelClick()" />

<form [formGroup]="dialogForm" *ngIf="dialogForm">
	<div class="frmcontainer">
		<div mat-dialog-content>
			<mat-form-field>
				<mat-label>Public Sensor ID:</mat-label>
				<input matInput [value]="dialogForm.get('PublicSensorID')?.value" readonly>
			</mat-form-field>

			<div class="compare-grid">
				<!-- LEFT: NEURON SENSOR -->
				<div class="compare-column readonly">
					<h3>Neuron Sensor</h3>
				</div>
				<div class="compare-column"><span></span></div>
				<div class="compare-column">
					<h3>PRISMPdM Sensor</h3>
				</div>
			</div>
			<div class="compare-grid">
				<!-- LEFT: NEURON SENSOR -->
				<div class="compare-column readonly">
					<mat-form-field>
						<mat-label>Name</mat-label>
						<input matInput [value]="dialogForm.get('NeuronName')?.value" readonly>
					</mat-form-field>
				</div>
				<div class="compare-column compare-arrow">
					<mat-icon class="sync-icon"
						[class.diff]="dialogForm.get('NeuronName')?.value !== dialogForm.get('Name')?.value"
						(click)="onNameArrowClick()">
						arrow_forward
					</mat-icon>
				</div>
				<div class="compare-column">
					<mat-form-field>
						<mat-label>Name</mat-label>
						<input matInput formControlName="Name" required>
						<mat-error *ngIf="dialogForm.get('Name')!.hasError('required')">
							<span>Sensor Name is required</span>
						</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="compare-grid">
				<!-- LEFT: NEURON SENSOR -->
				<div class="compare-column readonly">
					<mat-form-field>
						<mat-label>Description</mat-label>
						<input matInput [value]="dialogForm.get('NeuronDescription')?.value" readonly>
					</mat-form-field>
				</div>
				<div class="compare-column compare-arrow">
					<mat-icon class="sync-icon"
						[class.diff]="dialogForm.get('NeuronDescription')?.value !== dialogForm.get('Description')?.value"
						(click)="onDescriptionArrowClick()">
						arrow_forward
					</mat-icon>
				</div>
				<!-- RIGHT: LOCAL SENSOR -->
				<div class="compare-column">
					<mat-form-field>
						<mat-label>Description</mat-label>
						<input matInput formControlName="Description">
					</mat-form-field>
				</div>
			</div>

			<div class="compare-grid" style="margin-bottom: 5px;">
				<!-- LEFT: NEURON SENSOR -->
				<div class="compare-column readonly ">
					<div class="neuron-image">
						<img [src]="dialogForm.get('NeuronImageURL')?.value" alt="Neuron Sensor Image" />
					</div>
				</div>
				<div class="compare-column compare-arrow">
					<mat-icon class="sync-icon" (click)="onImageArrowClick()">arrow_forward</mat-icon>
				</div>
				<!-- RIGHT: LOCAL SENSOR -->
				<div class="compare-column">
					<app-image-container [imgURL]="dialogForm.get('ImageSrc')?.value" [enablePicture]="enablePicture"
						[enableCamera]="enableCamera" [enableDelete]="enableDelete" (onDelete)="deleteImg()"
						(onNewImage)="onNewImage($event)">
					</app-image-container>
				</div>
			</div>
			<div class="md-form mb-1 matFormSlider">
				<div>
					<mat-label>Enabled for Data Collection</mat-label>
					<mat-slide-toggle #switchEnabled formControlName="Enabled" color="primary"></mat-slide-toggle>
				</div>
			</div>
			<div class="md-form mb-1 matFormSlider">
				<div>
					<mat-label>Enabled Offline Notification</mat-label>
					<mat-slide-toggle #switchOfflineNotification formControlName="EnableOffline"
						color="primary"></mat-slide-toggle>
				</div>
			</div>
		</div>
	</div>
	<!-- ACTIONS -->
	<div mat-dialog-actions>
		<button mat-button (click)="onSaveClick()" [disabled]="dialogForm.invalid || !dialogForm.dirty || SavingData">Ok</button>
		<button mat-button (click)="onCancelClick()" [disabled]="SavingData" cdkFocusInitial>Cancel</button>
	</div>
</form>